module.exports = __webpack_public_path__ + "media/Transition_1.cb8a47c8.mp3";